<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card">
        <vs-list>
          <vs-list-header title="한문장씩 녹음 버튼을 누르고 발음하세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        </vs-list>

      <perfect-scrollbar>
        <vs-list class="inner-scroll-height">
          <vs-list-item v-for="(content, index) in contentList" :class="contentIndex===index ? 'msg-grp-container text-primary list-item ' : 'msg-grp-container list-item'" 
            :key="index" 
            :title="(contentIndex === index) && hint ? content.sentence : content.dictation"
            :subtitle="content.translation" >
            <vue-record-audio v-if="((contentIndex === index) && isRecording)" class="record-audio" :mode="recordMode.audio" @result="onResult" />
          </vs-list-item>
        </vs-list>
      </perfect-scrollbar>

      <div class="text-center">
        <audio ref="audioPlayer" v-show="!isRecording"
            controls
            v-on:ended="audioFinish"
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    PerfectScrollbar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      isRecording: true,
      hint: false
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.hint = false
      this.isRecording = true
      this.startAlert()
    },
    onStart () {
    },
    audioFinish () {

      if (this.contentIndex >= this.contentsLen - 1) {
        this.onComplete()
      } else {

        setTimeout(function () {
          this.contentIndex++
          this.audioPlayer.src = this.content.audio
          this.audioPlayer.play()
        }.bind(this), 1000)
      }
    },
    audioPlay () {
      this.isRecording = false
      this.hint = true // 녹음된 음원을 플레이할때는 sentence를 보여준다.
      this.contentIndex = 0
      
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    onResult (data) {
      this.content.audio = window.URL.createObjectURL(data)
      if (this.contentIndex >= this.contentsLen - 1) {
        this.$vs.dialog({
          color: 'primary',
          title: '듣기',
          text: '녹음된 발음을 듣습니다.',
          accept: this.audioPlay
        })
      } else {
        this.contentIndex++
      }
    },
    startAlert () {
      this.startStudyDlg('문장을 암기하여 발음합니다.')
    },
    acceptAlert () {
      this.onStart()
    },
    onHint () {
      this.hint = true
      setTimeout(function () {
        this.hint = false
      }.bind(this), 2000)
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        dictation: contentJson.dictation[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>

<style scoped>
.list-item {
  min-height: 60px
}
.record-audio {
  width:50px;
  height:50px
}

 
</style>